import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import MaintenanceWorkflowForwardingShow from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/MaintenanceWorkflowForwardingShow'
import MaintenanceWorkflowForwardingShowLoading from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/MaintenanceWorkflowForwardingShowLoading'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { useMaintenanceWorkflowForwardings } from '@/features/maintenanceWorkflow/pages/Show/hooks/useMaintenanceWorkflowForwardings'
import { MaintenanceWorkflowForwardingsData } from '@/features/maintenanceWorkflow/pages/Show/types/maintenanceWorkflowForwardings.type'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { useMemo } from 'react'

interface MaintenanceWorkflowForwardingsTabProps {
  workflow?: MaintenanceWorkflowData
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass
}

const MaintenanceWorkflowForwardingsTab = ({
  workflow,
  directiveEntryKlass,
}: MaintenanceWorkflowForwardingsTabProps) => {
  const {
    data: forwardings,
    isPending: forwardingsIsPending,
    error: forwardingsError = {} as any,
    refetch: refetchForwardings,
    dataUpdatedAt: forwardingsUpdatedAt,
  } = useMaintenanceWorkflowForwardings<MaintenanceWorkflowForwardingsData[]>({
    workflowId: workflow?.id,
    filters: {
      directiveEntryType: directiveEntryKlass,
    },
  })

  const forwarding = useMemo(() => {
    return forwardings?.[0]
  }, [forwardingsUpdatedAt])

  if (forwardingsIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper className="flex-1" statusCode={forwardingsError?.status} refetchFunction={refetchForwardings}>
      <div className="flex-1 overflow-auto flex flex-col">
        {forwarding && (
          <MaintenanceWorkflowForwardingShow
            key={forwarding.id}
            workflow={workflow}
            forwardingId={forwarding.id}
            directiveEntryKlass={directiveEntryKlass}
          />
        )}
      </div>
    </ErrorMessageWrapper>
  )
}

export default MaintenanceWorkflowForwardingsTab
